export default "{\n    \"emptyText\": \"Select a staff member\",\n    \"placeholderText\": \"Search by name, email or username\"\n}\n"